import React from 'react';
import { useTranslation } from 'react-i18next';
import { LegalDocument } from '../../commons/legalDocument/legalDocumentObject';
import ExpandableHeader from '../components/commons/ExpandableHeader';
import LegalDocumentSection from '../components/legalDocument/LegalDocumentSection';
import DownloadSection from '../sections/DownloadSection';
import Footer from '../sections/Footer';

const Terms = () => {
  const { t } = useTranslation('terms');
  const terms: LegalDocument = t('legalDocument', { returnObjects: true });
  return (
    <ExpandableHeader>
      <LegalDocumentSection inputText={terms} />
      <DownloadSection
        subtitle={t('home:download.subtitle')}
        title={t('home:download.title')}
        downloadTitle={t('home:download.download-title')}
      />
      <Footer />
    </ExpandableHeader>
  );
};

export default Terms;
